export default "__VITE_ASSET__BQi$pdoy__"